import React from 'react'
import { Card, Tabs } from 'antd'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import ArticleComp from './components/articleComp'
import OnlineSubmissionComp from './components/onlineSubmissionComp'


const { TabPane } = Tabs
const searchResults = (props) => {

  return (
    <PageHeaderWrapper title={`Search Results`}>
      <Card bordered={true}>

        <Tabs defaultActiveKey='1'>

          {/* TAB 1: EXISTING ARTICLE SEARCH */}
          <TabPane tab='Articles' key='1'>
            <ArticleComp {...props} />
          </TabPane>

          {/* TAB 2: ONLINE SUBMISSIONS */}
          <TabPane tab='Old Submissions' key='2'>

            <OnlineSubmissionComp {...props} />
          </TabPane>

        </Tabs>

      </Card>
    </PageHeaderWrapper>

  )
}

export default searchResults
